import { createFileRoute } from '@tanstack/react-router'
import DwvConfigPage from '@/pages/dashboard/dwv-config-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/dwv',
)({
  component: DwvConfigPage,
})
